import { useEffect, useState } from 'react';
import * as THREE from 'three';

import { Flavor } from '../../../types';

import { label } from './materials';
import { cleanTexture } from './utils';

const path = "/static/images/labels/back";

const useBackTexture = (flavor: Flavor) => {
  /**
   * Load texture
   */
  const [textures, setTextures] = useState<THREE.Texture[]>([]);

  useEffect(() => {
    const loader = new THREE.TextureLoader();

    const promises = [
      loader.loadAsync(`${path}/apple.png`),
      loader.loadAsync(`${path}/blackberry.png`),
      loader.loadAsync(`${path}/blueberry.png`),
      loader.loadAsync(`${path}/elderflower.png`),
      loader.loadAsync(`${path}/mango.png`),
      loader.loadAsync(`${path}/pear.png`),
      loader.loadAsync(`${path}/redrhubarb.png`),
      loader.loadAsync(`${path}/watermelon.png`)
    ];

    Promise.all(promises).then(textures => {
      textures.forEach(texture => cleanTexture(texture));
      setTextures(textures);
    });
  }, []);

  /**
   * Change cider color and flavor
   */
  useEffect(() => {
    if (textures.length === 8) {
      switch (flavor) {
        case "apple": label.back.map = textures[0]; break;
        case "blueberry": label.back.map = textures[1]; break;
        case "blackberry": label.back.map = textures[2]; break;
        case "elderflower": label.back.map = textures[3]; break;
        case "mango": label.back.map = textures[4]; break;
        case "pear": label.back.map = textures[5]; break;
        case "redrhubarb": label.back.map = textures[6]; break;
        case "watermelon": label.back.map = textures[7]; break;
      }
    }
  }, [flavor, textures.length]);
}

export default useBackTexture;